<div class="hs-add-credit-debit-card-wrapper">
  <div
    class="header"
    dsContent
    [contentPath]="'billing.paymentMethodStandAlone.addCardHeader'"
  ></div>
  <div class="flex subheading" style="margin-top: var(--spacing-spacing-5)"><ds-we-accept /></div>
  <div class="flex" style="margin-top: var(--spacing-spacing-5)" id="iframe-container"></div>
  <div style="margin-top: var(--spacing-spacing-5)">
    <call-to-action
      [primaryButtonName]="primaryButtonName"
      (primaryEvent)="savePaymentMethod()"
      [fullWidthButtons]="true"
      [disablePrimaryButton]="(this.isValid$ | async) === false"
      [secondaryButtonName]="'Cancel'"
      (secondaryEvent)="closeModal()"
    ></call-to-action>
  </div>
</div>
